import * as Api from "@api";
import React from "react";
import * as C from "@/components/ImageCard/ImageCardSection";
import VadImage from "vadimages-nextjs-image-optimizer";
import OrangeArrow from "./OrangeArrow";
import {Card, PageSection} from "@components";
import TipsTricksCard from "@/parts/TipsTricksSection/TipsTricksCard";

interface ITipsTricksSectionProps {
    sectionSlug: string;
    pageContent: Record<string, Api.ContentItem>;
    additionalNode?: React.ReactNode;
}

const TipsTricksSection = ({ pageContent, sectionSlug, additionalNode }: ITipsTricksSectionProps) => {
    const allProductsSlugs = Object.keys(pageContent)
        .filter((slug) => slug.startsWith(sectionSlug) && slug.endsWith('headline'))
        .map((slug) => slug.split('.')[2]);

    const productType = sectionSlug.split('.')[1];

    return <PageSection>
        <h2 className="text-center pb-16">{pageContent[`${sectionSlug}.title`]?.data ?? "Batteries"}</h2>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
            {
                allProductsSlugs.map((slug) => (
                    <TipsTricksCard
                        pageContent={pageContent}
                        sectionSlug={sectionSlug}
                        productType={productType}
                        slug={slug}
                        key={slug}
                    />
                ))
            }
        </div>
        {additionalNode}
    </PageSection>
}

export default TipsTricksSection;
